import type React from 'react'

import { sha256 } from '@/helpers/sha256'
import { getCookie, setCookie } from '@/helpers/cookies.browser'
import { useAnalyticsData } from '@/hooks/analyticsData'
import { handleIdentify } from '@/hooks/analyticsData/helpers/handleIdentify'
import { trackEmitter } from '@/hooks/analyticsData/helpers/trackEmitter'


import { useEffect } from 'react';
const TEST_ENV_VISITORS_NAME = 'test-env-visitors'

/**
 * 事件总线监听器：桥接 trackEmitter → useAnalyticsData
 */
const CustomTrack: React.FC = () => {
  const { trackCustomEvent } = useAnalyticsData()

  // 测试环境种 cookie，生产环境检测到此 cookie 会跳过上报
  useEffect(() => {
    if (
      process.env.NEXT_PUBLIC_APP_ENV === 'test' &&
      !getCookie(TEST_ENV_VISITORS_NAME)
    ) {
      setCookie(TEST_ENV_VISITORS_NAME, '1', {
        path: '/',
        maxAge: 60 * 60 * 24 * 100, // 100 天
      })
    }
  }, [])

  useEffect(() => {
    const unbind = trackEmitter.on('track-event', (props) => {
      trackCustomEvent(props)
    })
    const unbindIdentify = trackEmitter.on('identify', async (props) => {
      const { userId, email } = props
      const emailSha256 = await sha256(email.toLowerCase())
      handleIdentify({
        userId,
        emailSha256,
      })
    })
    return () => {
      unbind()
      unbindIdentify()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

export default CustomTrack
